import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/logo@2x.png")